import { useAppStore } from "@/store/appStore";

/**
 * Custom hook that retrieves the company ID based on the provided company name.
 * Falls back to the current company from the app store if no company name is provided.
 *
 * @param companyName - The name of the company to find the ID for. If empty or undefined, uses the current company from the store.
 * @returns The ID of the company if found in the company list, otherwise undefined.
 */
export const useCompanyId = (companyName?: string): number | undefined =>
  useAppStore((state) => {
    const name = companyName || state.currentCompany;
    return state.companyList?.find((c) => c?.name === name)?.id;
  });
